export interface ApiImage {
    id?: string
    url?: string
}

export const getImageId = (image: ApiImage) => image.id ?? ''

export const getImageUrl = (image: ApiImage) => `https:${image.url}` ?? ''